import { Component, input, model, output, ChangeDetectionStrategy } from '@angular/core';

/**
 * Dialog component shown when the user tries to leave unsaved work behind.
 * Provides three options:
 * - Save: Save the form and navigate away
 * - Don't Save: Clear local form and navigate away
 * - Cancel: Stay on the current page
 */
@Component({
  selector: 'app-unsaved-changes-dialog',
  standalone: true,
  templateUrl: './unsaved-changes-dialog.component.html',
  styleUrl: './unsaved-changes-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnsavedChangesDialogComponent {
  // Two-way binding with model signal
  readonly visible = model(false);

  /** Overridable so callers other than the form builder can name what is unsaved. */
  readonly message = input('You have unsaved changes in your form. Would you like to save before leaving?');

  // Signal outputs for each action
  readonly save = output<void>();
  readonly dontSave = output<void>();
  readonly cancel = output<void>();

  onSave(): void {
    this.save.emit();
    this.close();
  }

  onDontSave(): void {
    this.dontSave.emit();
    this.close();
  }

  onCancel(): void {
    this.cancel.emit();
    this.close();
  }

  close(): void {
    this.visible.set(false);
  }
}
